"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethaneFromTitan = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var MethaneFromTitan = (function (_super) {
    __extends(MethaneFromTitan, _super);
    function MethaneFromTitan() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.METHANE_FROM_TITAN,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE],
            cost: 28,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(2); }),
            metadata: {
                description: 'Requires 2% oxygen. Increase your heat production 2 steps and your plant production 2 steps.',
                cardNumber: '018',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.production(function (pb) {
                    pb.heat(2).br;
                    pb.plants(2);
                }); }),
                victoryPoints: 2,
            },
        }) || this;
    }
    MethaneFromTitan.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.HEAT, 2);
        player.addProduction(Resources_1.Resources.PLANTS, 2);
        return undefined;
    };
    MethaneFromTitan.prototype.getVictoryPoints = function () {
        return 2;
    };
    return MethaneFromTitan;
}(Card_1.Card));
exports.MethaneFromTitan = MethaneFromTitan;
//# sourceMappingURL=MethaneFromTitan.js.map